export const SIDEBAR_MENU_KEYS = {
  tutorial: 'tutorial-menu',
  normal: 'normal-menu',
  codeSandbox: 'code-sandbox-menu',
} as const
